import isNil from "lodash-es/isNil";
import { observer } from "mobx-react-lite";

import type { Product } from "../common/types/productTypes";

import productStore from "../stores/product/productStore";
import TrackedAlert from "./TrackedAlert";

type LeadTimeWarningProps = {
   sku?: string;
   product?: Product;
   className?: string;
};

const LeadTimeWarning = ({ sku, product, className = "" }: LeadTimeWarningProps) => {
   const productData = product ? product : productStore.resolveSku(sku);
   if (productData === undefined) {
      return null;
   }
   const hasLeadTime = !isNil(productData.leadTime);
   const isMiniTank = productData.miniTank;
   if (!hasLeadTime && !isMiniTank) {
      return null;
   }

   const alertTracking = {
      context: "lead_time",
      text: "lead_time_warning"
   };

   const alertInfoText = isMiniTank
      ? "En minitank kan ikke reduseres i antall eller slettes etter innsending av ordre."
      : "Dette produktet er ikke mulig å levere på kort varsel.";
   return (
      <div className={className}>
         <TrackedAlert fullWidth variant="information" showCloseButton={false} source="LeadTimeWarning" tracking={alertTracking}>
            <p className="m-0 text-xs">{alertInfoText}</p>
            {hasLeadTime ? (
               <p className="m-0 text-xs">
                  Leveringstid: <strong>{productData.leadTime} dager</strong>
               </p>
            ) : null}
         </TrackedAlert>
      </div>
   );
};

export default observer(LeadTimeWarning);
